import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { CartProvider } from './components/CartContext';
import Navbar from './components/Navbar';
import BookForm from './components/BookForm';
import AuthorForm from './components/AuthorForm';
import CustomerForm from './components/CustomerForm';
import CartForm from './components/CartForm';
import OrderList from './components/OrderList';
import Home from './pages/Home';
import { Toaster } from 'react-hot-toast';

function App() {
  return (
    <CartProvider>
      <Router>
        <div className="min-h-screen bg-gray-100 App">
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/books" element={<BookForm />} />
            <Route path="/authors" element={<AuthorForm />} />
            <Route path="/customers" element={<CustomerForm />} />
            <Route path="/cart" element={<CartForm />} />
            <Route path="/orders" element={<OrderList />} />
          </Routes>
          <Toaster position="top-right" toastOptions={{ duration: 3000 }} />
        </div>
      </Router>
    </CartProvider>
  );
}

export default App;